import { getLevelApartmentTypeCounts as i } from "../../metrics/apartment-distribution/index4.js";
function u(e, t) {
  const r = i(e, t).map((o) => ({
    ...o,
    level: t
  }));
  return { floor: t, mixes: r };
}
export {
  u as getStoryDistributionForLevel
};
//# sourceMappingURL=index3.js.map
